import { CreditApplicationStatus, CreditApplicationHistoryStatus } from '@dill/dill-shared';
import {
  CheckCircle,
  ClockClockwise,
  Timer,
  Warning,
  ClockAfternoon,
  PaperPlaneTilt,
  Alarm,
} from 'phosphor-react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const AppCreditApplicationStatus = ({
  status,
  wrapperClassName,
}: {
  status?: CreditApplicationStatus | CreditApplicationHistoryStatus | null;
  wrapperClassName?: string;
}) => {
  return (
    <div className={twMerge(' w-32', wrapperClassName || '')}>
      <div
        className={twMerge(
          'text-xs capitalize font-bold py-1.5 px-3 rounded-full w-fit text-start flex items-center justify-start',
          status === 'APPROVED' ||
            status === 'APPROVED_COD' ||
            status === 'INTERNALLY_APPROVED' ||
            status === 'INTERNALLY_APPROVED_COD'
            ? 'SUCCESS_100-BG SUCCESS_500-CLR'
            : status === 'DRAFT' ||
              status === 'OPENED' ||
              status === 'AWAITING_SIGNATURE' ||
              status === 'SENT'
            ? 'GREY_100-BG GREY_500-CLR'
            : status === 'REJECTED' || status === 'INTERNALLY_REJECTED'
            ? 'ERROR_100-BG ERROR_500-CLR'
            : status === 'IN_REVIEW' ||
              status === 'APPLICATION_UPDATED' ||
              status === 'READY_FOR_DECISION'
            ? 'INFO_100-BG INFO_500-CLR'
            : status === 'SUBMITTED' ||
              status === 'FEEDBACK_SENT' ||
              status === 'INTERNAL_SIGNATURE'
            ? 'WARNING_100-BG WARNING_500-CLR'
            : ''
        )}>
        <div>
          {(status === 'APPROVED' ||
            status === 'APPROVED_COD' ||
            status === 'APPLICATION_UPDATED' ||
            status === 'INTERNALLY_APPROVED' ||
            status === 'INTERNALLY_APPROVED_COD') && <CheckCircle size={15} weight="bold" />}
          {(status === 'SENT' || status === 'FEEDBACK_SENT') && (
            <PaperPlaneTilt size={15} weight="bold" />
          )}
          {(status === 'AWAITING_SIGNATURE' || status === 'DRAFT') && (
            <Timer size={15} weight="bold" />
          )}
          {(status === 'REJECTED' || status === 'INTERNALLY_REJECTED') && (
            <Warning size={15} weight="bold" />
          )}
          {(status === 'SUBMITTED' || status === 'INTERNAL_SIGNATURE') && (
            <ClockAfternoon size={15} weight="bold" />
          )}
          {(status === 'IN_REVIEW' || status === 'OPENED') && (
            <ClockClockwise size={15} weight="bold" />
          )}
          {status === 'READY_FOR_DECISION' && <Alarm size={15} weight="bold" />}
        </div>
        <p className="ml-2 capitalize text-xs">
          {status ? status.replaceAll('_', ' ').toLowerCase().replace('cod', 'COD') : ''}
        </p>
      </div>
    </div>
  );
};

export default AppCreditApplicationStatus;
